import React, { useState, useEffect } from "react";
import Autocomplete from "@mui/material/Autocomplete";
import {
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  Button,
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  IconButton,
  useMediaQuery,
  useTheme,
  Grid,
  TextField,
  FormLabel,
  FormHelperText,
} from "@mui/material";
import DeleteIcon from "@material-ui/icons/Delete";
import logo from "./logo.png";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { CreateTwoTone } from "@material-ui/icons";
import Message from "./Message";
import Formservice from "./../service/Formservice";
import PGIService from "./../service/PGIService";
import Menu from "./Menu";
import { LoadingButton } from "@mui/lab";
import NB from "./reusable/NB";
import Identifiant from "./reusable/Identifiant";
import useToast from "../hooks/useToast";
import { TYPE_NOTIFICATION } from "./utils/NotificationBull";

const INIT_FORM_ERROR = {
  domaine_error: null,
  theme_error: null,
  date_debut_error: null,
  date_fin_error: null,
  organisme_error: null,
  certificat_error: null,
};

function DomaineCompetence() {
  const navigate = useNavigate();
  const location = useLocation();
  // const params = new URLSearchParams(location.search);
  const ref = localStorage.getItem("ref");
  const [identif, setIdentif] = useState([]);
  const [submited, setSubmited] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const { Toast, showToast } = useToast();
  const [desc, setDesc] = useState({ desc: "" });
  const parts = ref.split("_");
  const prefix = parts[0];
  const apiurl = process.env.REACT_APP_API_FILE;
  const [message, setMessage] = React.useState({
    open: false,
    color: "green",
    messageInfo: "",
  });
  const [formErrrors, setFormErrors] = useState(INIT_FORM_ERROR);
  const { open, color, messageInfo } = message;
  const [form, setForm] = useState({
    domaine: "",
    compt: "",
  });
  const [formation, setFormation] = useState({
    id: "",
    domaine: "",
    theme: "",
    datedebut: "",
    datefin: "",
    fid: "",
    autres: "",
    certificat: "",
    jour: "",
    mois: "",
    annee: "",
    jour1: "",
    mois1: "",
    annee1: "",
    attestation: null,
  });
  const years = [];
  const currentYear = 31;

  for (let year = 1; year <= currentYear; year++) {
    years.push(year.toString());
  }

  const years1 = [];
  const currentYear1 = new Date().getFullYear();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  for (let year = 1950; year <= currentYear1; year++) {
    years1.push(year);
  }

  const [tableData, setTableData] = useState([]);
  const [tableData1, setTableData1] = useState([]);

  const handleChangejour = (event, value) => {
    setForm((prevForm) => ({
      ...prevForm,
      jour: value,
    }));
  };

  function onFileChange(event) {
    const file = event.target.files[0];

    if (file) {
      const fileSize = file.size;
      const maxFileSize = 3 * 1024 * 1024;

      if (fileSize > maxFileSize) {
        setMessage({
          ...message,
          open: true,
          color: "red",
          messageInfo:
            "Le fichier est trop volumineux. La taille maximale est de 3 Mo.",
        });

        event.target.value = "";
        setFormation({ ...formation, attestation: "" });
      } else {
        console.log("file:", file);
        setFormation({ ...formation, attestation: file });
        // setIsEdit(false);
      }
    }
  }

  const handleDelete = (index) => {
    Formservice.deletecompetence(index, ref)
      .then((result) => {
        if (result.status) {
          setMessage({
            ...message,
            open: true,
            color: "green",
            messageInfo: "Succès",
          });
          setTableData(result.data);
        } else {
          setMessage({
            ...message,
            open: true,
            color: "red",
            messageInfo: "Erreur",
          });
        }
      })
      .catch((err) => {
        setMessage({
          ...message,
          open: true,
          color: "red",
          messageInfo: "erreur",
        });
      });
  };

  const handleEdit = (index) => {
    let result = tableData1.find((item) => item.formation_id === index);
    console.log(result);
    setFormation({
      id: result.formation_id,
      domaine1: result.domaine,
      theme: result.theme,
      datedebut: "",
      datefin: "",
      fid: result.fid,
      autres: result.autres,
      certificat: result.certificat,
      jour: result.jour,
      mois: result.mois,
      annee: result.annee,
      jour1: result.jour1,
      mois1: result.mois1,
      annee1: result.annee1,
    });
  };

  const handleDelete1 = (index) => {
    PGIService.deleteformation(index, ref)
      .then((result) => {
        if (result.status) {
          setMessage({
            ...message,
            open: true,
            color: "green",
            messageInfo: "Succès",
          });
          setTableData1(result.data);
        } else {
          setMessage({
            ...message,
            open: true,
            color: "red",
            messageInfo: "Erreur",
          });
        }
      })
      .catch((err) => {
        setMessage({
          ...message,
          open: true,
          color: "red",
          messageInfo: "erreur",
        });
      });
  };

  const handleCheckError = () => {
    setFormErrors({
      certificat_error:
        (!formation.attestation || formation.attestation === "") &&
        identif.desc === "Cons_indiv"
          ? "Certificat/Attestation requis"
          : null,
      date_debut_error:
        !formation.annee || !formation.mois
          ? "Mois et année de la date debut requisent"
          : null,
      date_fin_error:
        !formation.annee1 || !formation.mois1
          ? "Mois et année de la date fin requisent"
          : null,
      domaine_error: !formation.domaine1 ? "Domaine requis" : null,
      organisme_error: !(formation.autres || formation.fid)
        ? "Organisme de formation requis"
        : null,
      theme_error: !formation.theme ? "Theme de formation requis" : null,
    });
    return Object.values(formErrrors).every((error) => error === null);
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setForm({ ...form, [name]: value });
  };

  const handleChangedesc = (event) => {
    const { name, value } = event.target;
    setDesc({ ...desc, desc: value });
  };

  const handleChange1 = (event) => {
    const { name, value } = event.target;
    setFormation({ ...formation, [name]: value });
  };

  const handleenvoie = () => {
    if (desc.desc === " ") {
      setMessage({
        ...message,
        open: true,
        color: "red",
        messageInfo: "Veuillez compléter le champ",
      });
    } else {
      if (desc.desc !== "") {
        Formservice.description(ref, desc)
          .then((result) => {
            if (result.status) {
              setMessage({
                ...message,
                open: true,
                color: "green",
                messageInfo: "Succès",
              });
            } else {
              setMessage({
                ...message,
                open: true,
                color: "red",
                messageInfo: "Erreur",
              });
            }
          })
          .catch((err) => {
            setMessage({
              ...message,
              open: true,
              color: "red",
              messageInfo: "erreur",
            });
          });
      }

      navigate("/autrecompetence");
    }
  };

  const handleAjout = () => {
    Formservice.competence(form, ref)
      .then((result) => {
        if (result.status) {
          showToast(TYPE_NOTIFICATION.SUCCESS, result.message);
          setTableData(result.data);
          setForm({
            domaine: "",
            compt: "",
          });
        } else {
          showToast(TYPE_NOTIFICATION.ERROR, result.message);
        }
      })
      .catch((err) => {
        showToast(TYPE_NOTIFICATION.SUCCESS, err.toString());
      });
  };

  const isFormError = () => {
    return Object.values(formErrrors).some((err) => err !== null);
  };

  const handleAjout1 = () => {
    setSubmited(true);
    if (isFormError()) {
      showToast(TYPE_NOTIFICATION.ERROR, "Veuillez verifier les champs");
      return;
    }
    setSubmitting(true);
    if (formation.id !== "") {
      PGIService.updateFormations(ref, formation)
        .then((result) => {
          if (result.status === 1) {
            setSubmited(false);
            handleInitField();
            showToast(TYPE_NOTIFICATION.SUCCESS, "Succès");
            setTableData1(result.data);
            setForm({
              domaine1: "",
              theme: "",
              datedebut: "",
              datefin: "",
              fid: "",
              autres: "",
              certificat: "",
              attestation: "",
            });

            document.getElementById("attestation").value = "";
          } else {
            showToast(TYPE_NOTIFICATION.ERROR, result.message);
          }
        })
        .catch((err) => {
          showToast(TYPE_NOTIFICATION.ERROR, err.toString());
        })
        .finally(() => {
          setSubmitting(false);
        });
    } else {
      setSubmitting(true);
      setSubmited(true);
      PGIService.formations(ref, formation)
        .then((result) => {
          if (result.status === 1) {
            setSubmited(false);
            handleInitField();
            showToast(TYPE_NOTIFICATION.SUCCESS, "Succès");
            setTableData1(result.data);
            setForm({
              domaine1: "",
              theme: "",
              datedebut: "",
              datefin: "",
              fid: "",
              autres: "",
              certificat: "",
            });

            document.getElementById("attestation").value = "";
          } else {
            showToast(TYPE_NOTIFICATION.ERROR, result.message);
          }
        })
        .catch((err) => {
          showToast(TYPE_NOTIFICATION.SUCCESS, err.toString);
        })
        .finally(() => {
          setSubmitting(false);
        });
    }
  };

  const handleInitField = () => {
    setFormation({
      id: "",
      domaine1: "",
      theme: "",
      datedebut: "",
      datefin: "",
      fid: "",
      autres: "",
      certificat: "",
      jour: "",
      mois: "",
      annee: "",
      jour1: "",
      mois1: "",
      annee1: "",
    });
  };

  function handleCloseMessage() {
    setMessage({ ...message, open: false });
  }

  const handleretour = () => {
    navigate("/experience");
  };

  useEffect(() => {
    Formservice.details(ref).then((result) => {
      if (result && result.data) {
        setIdentif(result.data);
        setDesc({ ...desc, desc: result.data.description });
      }
    });
    Formservice.getcompetence(ref).then((result) => {
      if (result && result.data) {
        setTableData(result.data);
      }
    });
    Formservice.getformation(ref).then((result) => {
      if (result && result.data) {
        setTableData1(result.data);
      }
    });
  }, []);

  useEffect(() => {
    handleCheckError();
  }, [formation]);

  return (
    <Grid container style={{ display: "flex", justifyContent: "center" }}>
      <Toast />
      <Message
        open={open}
        color={color}
        messageInfo={messageInfo}
        handleClose={handleCloseMessage}
      />
      <Menu />
      <Grid
        item
        xs={12}
        md={10}
        lg={7}
        minHeight={"90vh"}
        borderRadius={"20px"}
        border={"2px rgba(11, 93, 208,0.5) solid "}
        boxShadow="0px 4px 10px rgba(7,71,161,0.4)"
        display={"flex"}
        flexDirection={"column"}
        p={2.5}
      >
        <main>
          <Grid container item xs={12} justifyContent={"center"}>
            <img
              src={logo}
              className="App-logo"
              alt="logo"
              style={{
                maxWidth: "75px",
                maxHeight: "75px",
                // marginLeft: "40%",
                // display: window.innerWidth <= 600 ? "block" : "none",
              }}
            />
          </Grid>
          <Grid container justifyContent="center">
            <h1 style={{ marginBottom: "10px", textAlign: "center" }}>
              Formations professionnelles
            </h1>
            <Grid container>
              <Grid item xs={12} md={6}>
                <Identifiant identif={identif} prefix={prefix} refer={ref} />
              </Grid>
              <Grid
                item
                xs={12}
                md={6}
                style={{ marginBottom: "20px", color: "red" }}
              >
                {/* <fieldset>
                  <legend>NB</legend>
                  <label>- Tous les champs avec * sont obligatoires.</label>
                  <br />
                  <label>
                    - Le bouton Ajouter permet d'enregistrer les études.
                  </label>
                  <br />
                  <label>
                    - Veuillez cliquer sur suivant pour passer au suivant.
                  </label>
                </fieldset> */}
                <NB
                  texts={[
                    "Tous les champs avec * sont obligatoires",
                    "Le bouton Ajouter permet d'enregistrer les formations suivies.",
                    "Veuillez cliquer sur suivant pour passer au suivant.",
                  ]}
                />
              </Grid>
              <Grid item xs={12}>
                <fieldset>
                  <legend> Mot clé pour te décrire</legend>
                  <Grid container>
                    <FormControl fullWidth>
                      <FormLabel>
                        Description (Sépare les mots par , ) *
                      </FormLabel>
                      <TextField
                        fullWidth
                        multiline
                        rows={2}
                        id="outlined-basic"
                        size="small"
                        placeholder="Sépare les mots par , "
                        variant="outlined"
                        name="desc"
                        value={desc.desc}
                        onChange={handleChangedesc}
                      />
                    </FormControl>
                  </Grid>
                </fieldset>
              </Grid>
              <Grid item xs={12}></Grid>
            </Grid>
          </Grid>
          <Grid container justifyContent="center">
            <fieldset>
              <legend> FORMATIONS</legend>
              <TableContainer
                component={Paper}
                sx={{ width: { xs: "88vw", md: "78vw", lg: "54vw" } }}
                style={{
                  marginTop: "10px",
                  marginBottom: "20px",
                }}
              >
                <Table>
                  <TableHead>
                    <TableRow
                      style={{ backgroundColor: "gray", padding: "0px" }}
                    >
                      <TableCell>Domaines de formations</TableCell>
                      <TableCell>Thèmes de Formation</TableCell>
                      <TableCell>Période</TableCell>
                      <TableCell>FID</TableCell>
                      <TableCell>Autres</TableCell>
                      <TableCell>Certificats /Attestations Obtenus</TableCell>
                      <TableCell>Action</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {tableData1.map((data, index) => (
                      <TableRow key={index}>
                        <TableCell>{data.domaine}</TableCell>
                        <TableCell>{data.theme}</TableCell>
                        <TableCell>
                          {data.jour !== "" &&
                          data.mois !== "" &&
                          data.annee !== ""
                            ? `${data.jour} ${data.mois} ${data.annee}`
                            : data.jour === "" &&
                                data.mois !== "" &&
                                data.annee !== ""
                              ? `${data.mois} ${data.annee}`
                              : data.jour === "" &&
                                  data.mois === "" &&
                                  data.annee !== ""
                                ? `${data.mois} ${data.annee}`
                                : ""}
                          -
                          {data.jour1 !== "" &&
                          data.mois1 !== "" &&
                          data.annee1 !== ""
                            ? `${data.jour1} ${data.mois1} ${data.annee1}`
                            : data.jour1 === "" &&
                                data.mois1 !== "" &&
                                data.annee1 !== ""
                              ? `${data.mois1} ${data.annee1}`
                              : data.jour1 === "" &&
                                  data.mois1 === "" &&
                                  data.annee1 !== ""
                                ? `${data.mois1} ${data.annee1}`
                                : ""}
                        </TableCell>

                        <TableCell>{data.fid}</TableCell>
                        <TableCell>{data.autres}</TableCell>
                        <TableCell>
                          {
                            <a
                              href={`${apiurl}/uploads/attestation_formation/${data.certificat}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{
                                // fontSize: "10px",
                                textDecoration: "none",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                display: "block",
                                width: "100%",
                                marginTop: "5px",
                              }}
                            >
                              PJ
                            </a>
                          }
                        </TableCell>
                        <TableCell>
                          <IconButton
                            aria-label="delete"
                            color="primary"
                            onClick={() => handleEdit(data.formation_id)}
                          >
                            <CreateTwoTone />
                          </IconButton>
                          <IconButton
                            aria-label="delete"
                            color="secondary"
                            onClick={() => handleDelete1(data.formation_id)}
                          >
                            <DeleteIcon />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
              <Grid container spacing={1}>
                <Grid item xs={12} md={3}>
                  <label>Domaines de formations * :</label>
                </Grid>
                <Grid item xs={12} md={9}>
                  <TextField
                    style={{ width: "100%" }}
                    id="outlined-basic"
                    size="small"
                    variant="outlined"
                    name="domaine1"
                    value={formation.domaine1}
                    onChange={handleChange1}
                    error={submited && formErrrors.domaine_error}
                    helperText={submited ? formErrrors.domaine_error : ""}
                  />
                </Grid>

                <Grid item xs={12} md={3}>
                  <label>Thèmes de Formation * :</label>
                </Grid>
                <Grid item xs={12} md={9}>
                  <TextField
                    style={{ width: "100%" }}
                    id="outlined-basic"
                    size="small"
                    variant="outlined"
                    name="theme"
                    value={formation.theme}
                    onChange={handleChange1}
                    error={submited && formErrrors.theme_error}
                    helperText={submited ? formErrrors.theme_error : ""}
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <label>Période * :</label>
                </Grid>
                <Grid item xs={12} md={9}>
                  <Grid container spacing={1}>
                    <Grid item xs={3}>
                      <FormControl
                        fullWidth
                        variant="outlined"
                        size="small"
                        style={{ width: "100%" }}
                      >
                        <InputLabel id="demo-simple-select-outlined-label">
                          Jour
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-outlined-label"
                          id="demo-simple-select-outlined"
                          label="Jour"
                          value={formation.jour}
                          name="jour"
                          onChange={handleChange1}
                        >
                          {years.map((year, index) => (
                            <MenuItem key={index} value={year}>
                              {year}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={5}>
                      <FormControl
                        fullWidth
                        variant="outlined"
                        size="small"
                        style={{ width: "100%" }}
                      >
                        <InputLabel id="demo-simple-select-outlined-label">
                          Mois
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-outlined-label"
                          id="demo-simple-select-outlined"
                          label="direction"
                          value={formation.mois}
                          name="mois"
                          onChange={handleChange1}
                        >
                          <MenuItem value="Janvier">Janvier</MenuItem>
                          <MenuItem value="Février">Février</MenuItem>
                          <MenuItem value="Mars">Mars</MenuItem>
                          <MenuItem value="Avril">Avril</MenuItem>
                          <MenuItem value="Mai">Mai</MenuItem>
                          <MenuItem value="Juin">Juin</MenuItem>
                          <MenuItem value="Juillet">Juillet</MenuItem>
                          <MenuItem value="Aôut">Aôut</MenuItem>
                          <MenuItem value="Septembre">Septembre</MenuItem>
                          <MenuItem value="Octobre">Octobre</MenuItem>
                          <MenuItem value="Novembre">Novembre</MenuItem>
                          <MenuItem value="Décembre">Décembre</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={4}>
                      <FormControl
                        fullWidth
                        variant="outlined"
                        size="small"
                        style={{ width: "100%" }}
                      >
                        <InputLabel id="demo-simple-select-outlined-label">
                          Année
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-outlined-label"
                          id="demo-simple-select-outlined"
                          label="Année"
                          value={formation.annee}
                          name="annee"
                          onChange={handleChange1}
                        >
                          {years1.map((year, index) => (
                            <MenuItem key={index} value={year}>
                              {year}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                  </Grid>
                  <FormHelperText sx={{ color: "error.main" }}>
                    {submited ? formErrrors.date_debut_error : ""}
                  </FormHelperText>
                </Grid>
                <Grid item xs={12} md={3}>
                  <label>à</label>
                </Grid>
                <Grid item xs={12} md={9}>
                  <Grid container spacing={1}>
                    <Grid item xs={3}>
                      <FormControl
                        fullWidth
                        variant="outlined"
                        size="small"
                        style={{ width: "100%" }}
                      >
                        <InputLabel id="demo-simple-select-outlined-label">
                          Jour
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-outlined-label"
                          id="demo-simple-select-outlined"
                          label="Jour"
                          value={formation.jour1 || ""}
                          name="jour1"
                          onChange={handleChange1}
                        >
                          {years.map((year, index) => (
                            <MenuItem key={index} value={year}>
                              {year}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={5}>
                      <FormControl
                        fullWidth
                        variant="outlined"
                        size="small"
                        style={{ width: "100%" }}
                      >
                        <InputLabel id="demo-simple-select-outlined-label">
                          Mois
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-outlined-label"
                          id="demo-simple-select-outlined"
                          label="direction"
                          value={formation.mois1}
                          name="mois1"
                          onChange={handleChange1}
                        >
                          <MenuItem value="Janvier">Janvier</MenuItem>
                          <MenuItem value="Février">Février</MenuItem>
                          <MenuItem value="Mars">Mars</MenuItem>
                          <MenuItem value="Avril">Avril</MenuItem>
                          <MenuItem value="Mai">Mai</MenuItem>
                          <MenuItem value="Juin">Juin</MenuItem>
                          <MenuItem value="Juillet">Juillet</MenuItem>
                          <MenuItem value="Aôut">Aôut</MenuItem>
                          <MenuItem value="Septembre">Septembre</MenuItem>
                          <MenuItem value="Octobre">Octobre</MenuItem>
                          <MenuItem value="Novembre">Novembre</MenuItem>
                          <MenuItem value="Décembre">Décembre</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={4}>
                      <FormControl
                        fullWidth
                        variant="outlined"
                        size="small"
                        style={{ width: "100%" }}
                      >
                        <InputLabel id="demo-simple-select-outlined-label">
                          Année
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-outlined-label"
                          id="demo-simple-select-outlined"
                          label="Année"
                          value={formation.annee1}
                          name="annee1"
                          onChange={handleChange1}
                        >
                          {years1.map((year, index) => (
                            <MenuItem key={index} value={year}>
                              {year}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                  </Grid>
                  <FormHelperText sx={{ color: "error.main" }}>
                    {submited ? formErrrors.date_fin_error : ""}
                  </FormHelperText>
                </Grid>
                <Grid
                  item
                  xs={12}
                  md={3}
                  style={{
                    display: identif.desc === "Cons_indiv" ? "none" : "flex",
                  }}
                >
                  <label>FID :</label>
                </Grid>
                <Grid
                  item
                  xs={12}
                  md={9}
                  style={{
                    fontSize: "20px",
                    display: identif.desc === "Cons_indiv" ? "none" : "flex",
                  }}
                >
                  <TextField
                    style={{ width: "100%" }}
                    id="outlined-basic"
                    size="small"
                    variant="outlined"
                    error={submited && formErrrors.organisme_error}
                    helperText={submited ? formErrrors.organisme_error : ""}
                    name="fid"
                    value={formation.fid}
                    onChange={handleChange1}
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <label>
                    {identif.desc === "Cons_indiv"
                      ? "Oragnisme ou Etablissement *:"
                      : "Autre : "}
                  </label>
                </Grid>
                <Grid item xs={12} md={9}>
                  <TextField
                    style={{ width: "100%" }}
                    id="outlined-basic"
                    size="small"
                    variant="outlined"
                    name="autres"
                    value={formation.autres}
                    onChange={handleChange1}
                    error={submited && formErrrors.organisme_error}
                    helperText={submited ? formErrrors.organisme_error : ""}
                  />
                </Grid>

                <Grid item xs={12} md={3}>
                  <label>Certificats /Attestations Obtenus *:</label>
                </Grid>
                <Grid item xs={12} md={9}>
                  {/* <TextField style={{ width: '100%', marginBottom: "30px" }} id="outlined-basic" size="small"  variant="outlined" name="certificat" value={formation.certificat} onChange={handleChange1} /> */}
                  <Grid item xs={12} md={9}>
                    <input
                      type="file"
                      id="attestation"
                      name="attestation"
                      accept=".pdf, .jpg, .jpeg, .png"
                      onChange={onFileChange}
                      style={{ width: "100%", marginBottom: "10px" }}
                    />
                    {formation.id !== "" && formation.certificat && (
                      <a
                        href={`${apiurl}/uploads/attestation_formation/${formation.certificat}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                          fontSize: "10px",
                          textDecoration: "none",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          display: "block",
                          width: "100%",
                          marginTop: "5px",
                        }}
                      >
                        {formation.certificat}
                      </a>
                    )}
                    <FormHelperText sx={{ color: "error.main" }}>
                      {submited ? formErrrors.certificat_error : ""}
                    </FormHelperText>
                  </Grid>
                </Grid>
              </Grid>

              <Grid container justifyContent="end">
                {formation.id !== "" ? (
                  <LoadingButton
                    loading={submitting}
                    variant="contained"
                    color="primary"
                    onClick={handleAjout1}
                  >
                    Modifier
                  </LoadingButton>
                ) : (
                  <LoadingButton
                    loading={submitting}
                    variant="contained"
                    color="primary"
                    onClick={handleAjout1}
                  >
                    Ajouter
                  </LoadingButton>
                )}
              </Grid>
            </fieldset>
          </Grid>
          <Grid
            item
            mt={3}
            mb={3}
            display={"flex"}
            justifyContent={"space-between"}
          >
            <Button variant="outlined" onClick={handleretour}>
              Retour
            </Button>
            <LoadingButton
              variant="outlined"
              sx={{ marginLeft: "auto" }}
              onClick={handleenvoie}
              color="primary"
            >
              Suivant
            </LoadingButton>
          </Grid>
        </main>
        <footer
          style={{
            color: "#0747a1",
            textAlign: "center",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          &copy; 2024 FID - FONDS D'INTERVENTION POUR LE DEVELOPPEMENT
        </footer>
      </Grid>
    </Grid>
  );
}

export default DomaineCompetence;
